<script setup>
import { industryList, industryCheckRetrieve } from '@/client'
import { useLohndatenStore } from '@/stores/lohndaten'
import { useTextStore } from '@/stores/texts'
import { client } from '@/lohnrechner'
import { inject, ref } from 'vue'

import format from 'string-format'
import { nextTick } from 'vue'

const store = useLohndatenStore()
const emit = defineEmits(['complete'])

const select$ = ref(null)
const branchenListe = ref(null)

async function searchBranche(query) {
  return new Promise((resolve) => {
    if (!store.beruf) {
      resolve([])
      return
    }
    // last_isc = showAll ? null : store.beruf?.isc_beruf
    industryList({ client: client, query: { search: query, job_id: store.beruf } }).then((list) => {
      branchenListe.value = list.data.results
      resolve(list.data.results.map((m) => ({ value: m.pk, label: m.name })))
    })
  })
}
let brancheName = ref(null)

async function berechnungPossible(pk) {
  let respone = await industryCheckRetrieve({
    client: client,
    path: { id: pk },
    query: { job_id: store.beruf }
  })
  let data = respone.data
  brancheName.value = data.name
  return data.valid
}

const berechnungNotPossible = ref(false)

function onClear() {
  store.branche = null
}

function onChange(option) {
  berechnungPossible(option).then((b) => {
    berechnungNotPossible.value = !b
    if (b) {
      store.branche = option
      emit('complete')
    } else {
      store.branche = null
      select$.value.clear()
    }
  })
}

let beruf = store.beruf

store.$subscribe(() => {
  if (beruf != store.beruf) {
    nextTick(() => {
      select$.value.updateItems(true).then(() => {
        select$.value.clear()

        nextTick(() => {
          let idx = branchenListe.value.findIndex((m) => m.pk == store.branche)
          if (idx > -1 && idx < 5) {
            select$.value.load(store.branche)
            store.branche = select$.value.value
          } else {
            select$.value.clear()
            store.branche = null
          }
        })
      })
    })
  }
  beruf = store.beruf
})

const textStore = useTextStore()
const t = inject('t')

let lang = textStore.language
textStore.$subscribe((mutation, state) => {
  if (state.language != lang) {
    setTimeout(() => {
      select$.value.updateItems(true).then(() => {
        select$.value.clear()
        setTimeout(() => {
          select$.value.load(store.branche)
        }, 1)
      })
    }, 1)
  }
  lang = state.language
})
</script>
<template>
  <SelectElement
    style="z-index: 3"
    :default="store.branche"
    ref="select$"
    :delay="100"
    :filter-results="false"
    :label="t('branche')"
    :placeholder="t('branche-frage')"
    :native="false"
    :rules="['required']"
    name="branche"
    :search="true"
    :can-clear="true"
    autocomplete="off"
    :items="searchBranche"
    @select="onChange"
    @clear="onClear"
  >
  </SelectElement>
  <StaticElement name="branche-hint">
    <div v-if="berechnungNotPossible" id="branche-hint">
      {{ format(t('berechung-leider-nicht-moeglich'), brancheName) }}
      <RouterLink :to="t('faq-branche-keine-berechnung-url')">{{ t('erfahre-mehr') }}</RouterLink>
    </div>
  </StaticElement>
</template>

<style scoped>
#branche-hint {
  padding-right: calc(var(--vf-px-input) * 2.5 + 20px);
  padding-left: 27px;
}
</style>
